export default __webpack_public_path__ + "static/gestalten-9be4bdf14550b1b5fff2a9a1e1bfa703.svg";